// @flow

import {
  GetClientContext,
  GetClientContextSuccess,
  GetClientContextError,
  SetClientContext,
  ClearClientContext,
} from "@modules/context/constants/actions";
import type { Client } from "@modules/context/types";
import { cloneObject } from "@utils/object";

export type ContextState = $Exact<{
  client: Client | null,
  error: string | null,
}>;

export const initialState: ContextState = {
  client: null,
  error: null,
};

export const onClearClientContext = (state: ContextState) => ({ payload }: Object) => {
  return {
    ...state,
    client: null,
  };
};

export const onGetClientContext = (state: ContextState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    client: null,
  };
};

export const onGetClientContextSuccess = (state: ContextState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    client: payload,
  };
};

export const onGetClientContextError = (state: ContextState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
  };
};

export const onSetClientContext = (state: ContextState) => ({ payload }: Object) => {
  return {
    ...state,
    client: payload,
  };
};

export default (state: ContextState = initialState, action: *): ContextState => {
  const act = {
    [ClearClientContext]: onClearClientContext,
    [GetClientContext]: onGetClientContext,
    [GetClientContextSuccess]: onGetClientContextSuccess,
    [GetClientContextError]: onGetClientContextError,
    [SetClientContext]: onSetClientContext,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
